module.exports = __webpack_public_path__ + "static/media/pack-items-ac-icon.ad2fb554.png";